export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8175.e89505f4.jpg";